import {View, Text} from 'react-native';
import React from 'react';
import {Colors} from '../../../../../../constants/Colors';
import ButtonComponent from '../../../../../../components/ButtonComponent/ButtonComponent';

interface ICompany {
  id: string;
  name: string;
  clientCode: string;
  cnpj_cpf: string;
  subchannel: string;
  user_id: number;
  ultimoPedido: string | null;
  address: {
    id: number;
    client_id: number;
    street: string;
    neighborhood: string;
    city: string;
    state: string;
    zip_code: string;
    created_at: string;
    updated_at: string;
  };
}

interface CompanyCardProps {
  company: ICompany;
  actualClient: boolean;
  onClientCodeUpdate?: (clientCode: string, cpfCnpj: string) => void;
  current_cnpj_cpf?: string;
}

const CompanyCard = ({
  company,
  onClientCodeUpdate,
  actualClient,
  current_cnpj_cpf
}: CompanyCardProps) => {
  const formatLastOrder = (date: string | null) => {
    if (!date) return 'Não disponível';
    try {
      return date.split('/').reverse().join('/');
    } catch (error) {
      return 'Data inválida';
    }
  };

  const formattedCnpjCpf = company.cnpj_cpf?.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    '$1.$2.$3/$4-$5'
  );
  
  const formattedZipCode = company.address?.zip_code?.replace(
    /(\d{5})(\d{3})/,
    '$1-$2'
  );
  
  const formattedLastOrder = company.ultimoPedido
    ? formatLastOrder(company.ultimoPedido)
    : 'Não disponível';
  


  const updateUserCompanyActiveClientCode = (clientCode: string) => {
    onClientCodeUpdate?.(clientCode, company?.cnpj_cpf);
  };

  return (
    <View
      style={{
        height: 320,
        width: '100%',
        backgroundColor: (actualClient || company?.cnpj_cpf == current_cnpj_cpf) ? Colors.GrayPallete.lightgrayTwo: 'white',
        marginTop: 30,
        paddingHorizontal: 15,
        paddingVertical: 30,
        borderRadius: 10,
        justifyContent: 'space-between',
        borderWidth: 1,
        borderColor: Colors.lightGray,
      }}>
      <Text
        style={{
          fontSize: 16,
          lineHeight: 20,
          fontFamily: 'TCCC-UnityText Bold',
          color: 'black',
        }}>
        {company?.name}
      </Text>
      <Text
        numberOfLines={4}
        style={{
          fontSize: 12,
          lineHeight: 22,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
        }}>
        CNPJ: {formattedCnpjCpf}
      </Text>
      <Text
        numberOfLines={4}
        style={{
          fontSize: 12,
          lineHeight: 22,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
        }}>
        Endereço: {company?.address?.street}, {company?.address?.neighborhood}
      </Text>
      <Text
        numberOfLines={4}
        style={{
          fontSize: 12,
          lineHeight: 22,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
        }}>
        Cidade: {company?.address?.city ?? company?.address?.neighborhood}
      </Text>
      <Text
        numberOfLines={4}
        style={{
          fontSize: 12,
          lineHeight: 22,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
        }}>
        Estado: {company?.address?.state}
      </Text>
      <Text
        style={{
          fontSize: 12,
          lineHeight: 25,
          fontFamily: 'TCCC-UnityHeadline Regular',
          color: 'black',
          marginBottom: 20,
        }}>
        Última compra: {formattedLastOrder || 'Não disponível'}
      </Text>
      <View style={{width: '100%', alignItems: 'center'}}>
        <ButtonComponent
          title={(actualClient || company?.cnpj_cpf == current_cnpj_cpf)  ? 'Ir para catálogo' : 'Acessar conta'}
          width="80%"
          onPress={() => updateUserCompanyActiveClientCode(company?.clientCode)}
        />
      </View>
    </View>
  );
};

export default CompanyCard;
